import { isEmpty } from "lodash";
import React, { useState } from "react";
import { setupEmergencyPincode } from "../../../../AxiosRtk/PinCode/PINCURD";
import useLangTranslation from "../../../../../customHooks/languageProvider";
import { useHistory } from "react-router-dom";
import { getSession, removeSession } from "../../../../../../utils/session";
import { setUser } from "../../../../AxiosRtk/Auth";
import { useDispatch } from "react-redux";
import LoadingIndicator from "../../../../../../setup/Loader/LoaderIndicator";
import { setter } from "../../../../../../utils/storage";
import { setShowMessage } from "../../../../AxiosRtk/successMessage";
import useCrypto from "../../../../../customHooks/crypto";
import { getAccessToken } from "../../../../../../utils/helper";

const EmergencyPinCode = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { decryptRequest } = useCrypto();
  const [loader, setLoader] = useState(false);
  const { getLangTranslation } = useLangTranslation();
  const [pwdType, setPwdType] = useState({
    pincode: "password",
    confirmPincode: "password",
  });
  const [pin, setPin] = useState({
    pincode: { value: "", error: "", errValue: "" },
    confirmPincode: { value: "", error: "", errValue: "" },
  });

  function handleInputChange(e) {
    const { name, value } = e.target;
    if (isNaN(value)) {
      setPin({
        ...pin,
        [name]: {
          value: pin?.[name]?.value,
          error: "Only numbers allowed",
        },
      });
    } else {
      setPin({
        ...pin,
        [name]: {
          value,
          error: "",
        },
      });
    }
  }

  function handleTogglePassword(type) {
    if (type === "pincode") {
      setPwdType({
        ...pwdType,
        pincode: pwdType?.pincode === "password" ? "text" : "password",
      });
    } else if (type === "confirmPincode") {
      setPwdType({
        ...pwdType,
        confirmPincode:
          pwdType?.confirmPincode === "password" ? "text" : "password",
      });
    }
  }

  function formValidate() {
    let flag = true;
    if (isEmpty(pin?.pincode?.value) && isEmpty(pin?.confirmPincode?.value)) {
      setPin({
        pincode: {
          value: "",
          error: "PINCODE_IS_REQUIRED",
          errValue: "Pincode is required",
        },
        confirmPincode: {
          value: "",
          error: "CONFIRM_PINCODE_REQUIRED",
          errValue: "Confirm pincode is required",
        },
      });
      flag = false;
    } else if (pin?.pincode?.value !== pin?.confirmPincode?.value) {
      setPin({
        ...pin,
        confirmPincode: {
          value: pin?.confirmPincode?.value,
          error: "NEW_PIN_CONFIRM_PIN_NOT_MATCHING",
          errValue: "New pincode and Confirm new pincode is not matching",
        },
      });
      flag = false;
    } else if (pin?.pincode?.value?.length !== 4) {
      setPin({
        ...pin,
        pincode: {
          value: pin?.pincode?.value,
          error: "PINCODE_MUST_HAVE_FOUR_DIGIT",
          errValue: "Pin code must have four digit",
        },
      });
      flag = false;
    }

    return flag;
  }

  function handlePinSave() {
    if (!formValidate()) {
      return;
    }

    const { accessToken } = getAccessToken(decryptRequest);
    setLoader(true);
    setupEmergencyPincode({ appLoginPin: (pin?.pincode?.value), accessToken })
      .then((res) => {
        dispatch(
          setShowMessage({
            showMessage: true,
            defaultMessage: res?.data?.message,
            message: res?.data?.message,
          })
        );
        dispatch(setUser(JSON.parse(decryptRequest(getSession("kidoProtectUser")))));

        setter("kidoProtectUser", getSession("kidoProtectUser"));
        setter("kidoProtectUserAccessToken",JSON.parse(decryptRequest(getSession("kidoProtectUser")))?.accessToken )
        setTimeout(() => {
          history.push("/dashboard");
        }, 2000);
      })
      .catch((error) => {
        console.log("error ==>>", error);
      })
      .finally(() => {
        setLoader(false);
        removeSession("kidoProtectUser");
        removeSession("kidoProtectUserAccessToken");
      });
  }

  return (
    <>
      <div className="container">
        <div className="auth-wrapper">
          <div className="auth-inner">
            <h2 className="mb-3 auth-sub-title fw-bolder text-center">
              {getLangTranslation(
                "CREATE_PIN_DESC",
                "Create a 4-digit pin code to log into the app in future"
              )}
            </h2>
            {/* <p className="mb-9 light-text">{getLangTranslation('Make_sure_you_save')}</p> */}
            <div className="mb-6 mt-6">
              <label htmlFor="pincode" className="form-label">
                {getLangTranslation("CREATE_PIN_ENTER_CODE", "Enter Code")}
              </label>
              <div className="input-group">
                <input
                  className="form-control"
                  type={pwdType?.pincode}
                  name="pincode"
                  placeholder={getLangTranslation(
                    "CREATE_PIN_ENTER_CODE",
                    "Enter Code"
                  )}
                  maxLength={4}
                  value={pin?.pincode?.value}
                  onChange={handleInputChange}
                />
                <span
                  className="input-group-text pt-cursor"
                  onClick={() => handleTogglePassword("pincode")}
                >
                  {pwdType?.pincode === "password" ? (
                    <i className="fa fa-eye-slash" id="togglePassword"></i>
                  ) : (
                    <i className="fa fa-eye" id="togglePassword"></i>
                  )}
                </span>
              </div>
              {pin?.pincode?.error && (
                <label className="field-error">
                  {getLangTranslation(pin?.pincode?.error)}
                </label>
              )}
            </div>
            <div className="mb-6">
              <label htmlFor="confirmPincode" className="form-label">
                {getLangTranslation("CREATE_PIN_CONFIRM_CODE", "Confirm Code")}
              </label>
              <div className="input-group">
                <input
                  className="form-control"
                  type={pwdType?.confirmPincode}
                  name="confirmPincode"
                  placeholder={getLangTranslation(
                    "CREATE_PIN_CONFIRM_CODE",
                    "Confirm Code"
                  )}
                  maxLength={4}
                  value={pin?.confirmPincode?.value}
                  onChange={handleInputChange}
                />
                <span
                  className="input-group-text pt-cursor"
                  onClick={() => handleTogglePassword("confirmPincode")}
                >
                  {pwdType?.confirmPincode === "password" ? (
                    <i className="fa fa-eye-slash" id="togglePassword"></i>
                  ) : (
                    <i className="fa fa-eye" id="togglePassword"></i>
                  )}
                </span>
              </div>
              {pin?.confirmPincode?.error && (
                <label className="field-error">
                  {getLangTranslation(
                    pin?.confirmPincode?.error,
                    pin?.confirmPincode?.errValue
                  )}
                </label>
              )}
            </div>
            <div className="d-grid">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handlePinSave}
                disabled={loader}
              >
                {loader ? (
                  <LoadingIndicator height={20} width={100} />
                ) : (
                  <span className="btn-upper-case text-white">
                    {getLangTranslation("SAVE", "Save")}
                  </span>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmergencyPinCode;
